import { checkServiceProvider } from './serviceProviderConfig';

export const reportAccordionConfigs = ({
  i18n,
  dutyStatusReport,
  driverPerformanceReport,
  editedDataReport,
  eldDisconnectReport,
  odometerJumpReport,
  malfunctionReport,
  unassignedDrivingReport,
  violationReport,
  hosViolationsReport,
  rejectedEditsReport,
  drivingEventReport,
  SERVICE_PROVIDER
}) => [
  {
    id: 'DUTY_STATUS',
    name: i18n.t('reportPage.dutyStatus'),
    reportKey: checkServiceProvider('dutyStatus_reportKey', SERVICE_PROVIDER, false),
    condition: () => checkServiceProvider('dutyStatus', SERVICE_PROVIDER),
    fn: dutyStatusReport
  },
  {
    id: 'DRIVER_PERFORMANCE_REPORT',
    name: i18n.t('reportPage.driverPerf'),
    reportKey: 'driverPerformanceReport',
    dependency: 'geometrisEnabled',
    condition: () => checkServiceProvider('driverPerformanceReport', SERVICE_PROVIDER),
    fn: driverPerformanceReport
  },
  {
    id: 'EDITED_DATA_REPORT',
    name: i18n.t('reportPage.editedData'),
    reportKey: 'editedDataReport',
    condition: () => checkServiceProvider('editedDataReport', SERVICE_PROVIDER),
    fn: editedDataReport
  },
  {
    id: 'REJECTED_EDITS',
    name: i18n.t('reportPage.rejectedEdits'),
    reportKey: 'driverPerformanceReport',
    fn: rejectedEditsReport
  },
  {
    id: 'DRIVING_EVENT_REPORT',
    name: i18n.t('reportPage.drivingEvents'),
    reportKey: 'drivingEventReport',
    fn: drivingEventReport
  },
  {
    id: 'ELD_DISCONNECT_REPORT',
    name: i18n.t('reportPage.eldDisconn'),
    reportKey: 'vehicleReport',
    dependency: 'geometrisEnabled',
    fn: eldDisconnectReport
  },
  {
    id: 'ODOMETER_JUMP_REPORT',
    name: i18n.t('reportPage.odoJump'),
    reportKey: 'vehicleReport',
    dependency: 'geometrisEnabled',
    fn: odometerJumpReport
  },
  {
    id: 'MALFUNCTION_REPORT',
    name: i18n.t('reportPage.malFunc'),
    reportKey: 'malFunctionReport',
    fn: malfunctionReport
  },
  {
    id: 'UNASSIGNED_DRIVING_REPORT',
    name: i18n.t('reportPage.unassigned'),
    reportKey: 'DateReportForm',
    fn: unassignedDrivingReport
  },
  {
    id: 'VIOLATION_REPORT',
    name: i18n.t('reportPage.violation'),
    reportKey: 'DateReportForm',
    fn: violationReport
  },
  {
    id: 'HOS_VIOLATIONS_DETAIL',
    name: i18n.t('reportPage.hos'),
    reportKey: 'driverPerformanceReport',
    fn: hosViolationsReport
  },
  {
    id: 'PENDING_MECHANIC',
    name: i18n.t('reportPage.pendingMechanic'),
    reportKey: 'companyFormReport',
    reportType: 'DVIR_PENDING_MECHANIC',
    condition: () => checkServiceProvider('pendingMechanic', SERVICE_PROVIDER, false)
  },
  {
    id: 'NO_OF_REQUESTS_PER_DAY',
    name: i18n.t('reportPage.noOfRequestsPerDay'),
    reportKey: 'companyFormReport',
    reportType: 'DVIR_REQUESTS_PER_DAY',
    condition: () => checkServiceProvider('noOfRequestsPerDay', SERVICE_PROVIDER, false)
  },
  {
    id: 'PAST_DUE_SERVICE_REQUEST',
    name: i18n.t('reportPage.pastDueServiceRequests'),
    reportKey: 'companyFormReport',
    reportType: 'DVIR_PAST_DUE_REQUESTS',
    condition: () => checkServiceProvider('pastDueServiceRequests', SERVICE_PROVIDER, false)
  },
  {
    id: 'PAST_DUE_SERVICE_REQUEST',
    name: i18n.t('reportPage.pastDueServiceRequests'),
    reportKey: 'DateReportForm',
    reportType: 'DVIR_PAST_DUE_REQUESTS',
    condition: () => checkServiceProvider('pastDueServiceRequests_dateReportForm', SERVICE_PROVIDER, false)
  },
  {
    id: 'PENDING_DRIVER_DVIR',
    name: i18n.t('reportPage.pendingDriverDVIR'),
    reportKey: 'DateReportForm',
    reportType: 'DVIR_PENDING_DRIVER',
    condition: () => checkServiceProvider('pendingDriverDVIR', SERVICE_PROVIDER, false)
  },
  {
    id: 'BORDER_STATES',
    name: i18n.t('reportPage.borderStates'),
    reportKey: 'driverPerformanceReport',
    reportType: 'DOCUMENT_TIME',
    dependency: 'borderStatesReportEnabled',
    condition: () => checkServiceProvider('borderStates', SERVICE_PROVIDER, false)
  },
  {
    id: 'BAY_INDUSTRIES_PAYROLL',
    name: i18n.t('reportPage.bayIndustriesPayroll'),
    reportKey: 'driverPerformanceReport',
    reportType: 'PAYROLL',
    dependency: 'bayIndustriesPayrollReportEnabled',
    condition: () => checkServiceProvider('bayIndustriesPayroll', SERVICE_PROVIDER)
  },
  {
    id: 'ALL_DUTY_TIME_TRACKER',
    name: i18n.t('reportPage.allDutyTimeTracker'),
    reportKey: 'driverPerformanceReport',
    reportType: 'ALL_DUTY_TIME_TRACKER',
    dependency: 'allDutyTimeTrackerReportEnabled',
    condition: () => checkServiceProvider('allDutyTimeTracker', SERVICE_PROVIDER)
  },
  {
    id: 'DTC',
    name: i18n.t('reportPage.dtc'),
    reportKey: 'vehicleReport',
    reportType: 'DTC'
  }
];

export const spireonExtraTabsConfig = ({
  i18n,
  dailyHosViolationReport,
  dailyUnsignedLogReport,
  dailyFailedInspectionReport,
  dailyUnidentifiedDrivingReport
}) => [
  {
    id: 'Daily_HOS_Driver_Violations_Report',
    name: i18n.t('reportPage.DailyHocDriverViolation'),
    reportKey: 'dailyHosViolationReportApi',
    dependency: '',
    fn: dailyHosViolationReport
  },
  {
    id: 'Daily_Unsigned_Log_Report',
    name: i18n.t('reportPage.dailyUnsignedLogReport'),
    reportKey: 'dailyUnsignedLogReportApi',
    dependency: '',
    fn: dailyUnsignedLogReport
  },
  {
    id: 'Daily_Failed_inspection_report',
    name: i18n.t('reportPage.DailyFailedInspectionReport'),
    reportKey: 'dailyFailedInspectionReportApi',
    dependency: '',
    fn: dailyFailedInspectionReport
  },
  {
    id: 'Daily_Unidentified_driving_report',
    name: i18n.t('reportPage.DailyUnidentifiedDrivingReport'),
    reportKey: 'dailyUnidentifiedDrivingReportApi',
    dependency: '',
    fn: dailyUnidentifiedDrivingReport
  }
];
